<template>
    <div v-if="content">
        <div class="d-flex justify-content-between align-items-start mb-4">
            <div>
                <div class="d-flex align-items-center gap-2 mb-1">
                    <button class="btn btn-sm btn-outline-secondary" @click="goBack">
                        <i class="fas fa-arrow-left"></i>
                    </button>
                    <h4 class="mb-0">{{ content.name }}</h4>
                    <span class="badge-type">{{ content.batchType }}</span>
                </div>
            </div>
            <div class="d-flex gap-2">
                <button class="btn btn-sm btn-outline-white" style="border: 1px solid black;" @click="saveBatch" :disabled="saving || isTableNameInvalid()">
                    <i class="fas fa-floppy-disk"></i> {{ $t('save') }}
                </button>
                <button class="btn btn-sm btn-primary" @click="runBatch" :disabled="running || isTableNameInvalid()">
                    <i class="fas fa-play"></i> {{ $t('saveAndRun') }}
                </button>
            </div>
        </div>
        <div class="card mb-3">
            <div class="card-body">
                <div class="col-md-3">
                    <label class="small fw-bold">{{ $t('name') }}</label>
                    <input v-model="content.name" class="form-control form-control-sm" />
                </div>
            </div>
        </div>
        <!-- Kopírování -->
        <div v-if="content.batchType === 'Copy'">
            <div class="card mb-3">
                <div class="card-body">
                    <div class="d-flex align-items-center gap-2 mb-3">
                        <div class="rounded-circle bg-primary-subtle text-primary d-inline-flex align-items-center justify-content-center" style="width: 36px; height: 36px;" >
                            <i class="fa-regular fa-file"></i>
                        </div>
                        <span class="fw-semibold">{{ $t('output') }}</span>
                    </div>
                    <div class="row g-2 mt-3">
                        <div class="col-md-3">
                            <label class="small fw-bold">{{ $t('outputTable') }}</label>
                            <input v-model="content.outputTableName" class="form-control form-control-sm" />
                        </div>
                        
                        <!-- <div class="col-md-3">
                            <label class="small text-muted">{{ $t('outputIdName') }}</label>
                            <input v-model="content.outputIdColumn" class="form-control form-control-sm" placeholder="objectId" />
                        </div>
                        <div class="col-md-3">
                            <label class="small text-muted">{{ $t('outputFromName') }}</label>
                            <input v-model="content.outputFromColumn" class="form-control form-control-sm" placeholder="from" />
                        </div>
                        <div class="col-md-3">
                            <label class="small text-muted">{{ $t('outputToName') }}</label>
                            <input v-model="content.outputToColumn" class="form-control form-control-sm" placeholder="to" />
                        </div> -->
                    </div>
                    <div class="row g-2 mt-3">
                        <div class="col-md-12">
                            <label class="small fw-bold">{{ $t('outputFilter') }}</label>
                            <input v-model="content.outputFilter" class="form-control form-control-sm" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="card mb-3">
                <div class="card-body">
                    <div class="d-flex align-items-center gap-2 mb-3">
                        <div class="rounded-circle bg-primary-subtle text-primary d-inline-flex align-items-center justify-content-center" style="width: 36px; height: 36px;" >
                            <i class="fa-regular fa-file"></i>
                        </div>
                        <span class="fw-semibold">{{ $t('input') }}</span>
                    </div>
                    <div class="row g-2 mt-3">
                        <div class="col-md-3">
                            <label class="small fw-bold">{{ $t('inputTable') }}</label>
                            <select v-model="content.inputTable" class="form-select form-select-sm" >
                                <option value="">{{ $t('selectTable') }}</option>
                                <option v-for="t in tables" :key="t.name" :value="t.name">{{ t.name }}</option>
                            </select>
                        </div>
                        <div class="col-md-3">
                            <label class="small text-muted">{{ $t('inputIdName') }}</label>
                            <select v-model="content.inputIdColumn" class="form-select form-select-sm" :disabled="!content.inputTable">
                                <option v-for="c in getColumnsForTable(content.inputTable)" :key="c.name" :value="c.name">{{ c.name }}</option>
                            </select>
                        </div>
                        <div class="col-md-3">
                            <label class="small text-muted">{{ $t('inputFromName') }}</label>
                            <select v-model="content.inputFromColumn" class="form-select form-select-sm" :disabled="!content.inputTable">
                                <option v-for="c in getColumnsForTable(content.inputTable)" :key="c.name" :value="c.name">{{ c.name }}</option>
                            </select>
                        </div>
                        <div class="col-md-3">
                            <label class="small text-muted">{{ $t('inputToName') }}</label>
                            <select v-model="content.inputToColumn" class="form-select form-select-sm" :disabled="!content.inputTable">
                                <option v-for="c in getColumnsForTable(content.inputTable)" :key="c.name" :value="c.name">{{ c.name }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="row g-2 mt-3">
                        <div class="col-md-12">
                            <label class="small fw-bold">{{ $t('inputFilter') }}</label>
                            <input v-model="content.inputFilter" class="form-control form-control-sm" />
                        </div>
                    </div>
                    <div class="row g-2 mt-3">
                        <div v-if="content.inputTable">
                            <div class="form-check border-bottom pb-2 mb-2">
                                <input class="form-check-input" type="checkbox" id="copy-all" :checked="allCopyChecked" @change="toggleAllCopyColumns">
                                <label class="form-check-label small fw-bold" for="copy-all">{{ $t('outputColumns') }}</label>
                            </div>
                            <div style="max-height: 300px; overflow-y: auto">
                                <div v-for="col in getColumnsForTable(content.inputTable)" :key="col.name" class="form-check">
                                    <input class="form-check-input" type="checkbox" :id="`copy-${col.name}`" :checked="!isExcluded(col.name)" :disabled="isKeyColumn(col.name)" 
                                        @change="toggleCopyColumn(col.name)">
                                    <label class="form-check-label small" :for="`copy-${col.name}`">
                                        {{ col.name }} <span class="text-muted">{{ col.dataType }}</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                  
                </div>
            </div>
        </div>

        <!-- Agregace -->
        <div v-if="content.batchType === 'Aggregation'">
            <div class="card mb-3">
                <div class="card-body">
                    <div class="d-flex align-items-center gap-2 mb-3">
                        <div class="rounded-circle bg-primary-subtle text-primary d-inline-flex align-items-center justify-content-center" style="width: 36px; height: 36px;" >
                            <i class="fa-regular fa-file"></i>
                        </div>
                        <span class="fw-semibold">{{ $t('output') }}</span>
                    </div>
                    <div class="row g-2 mt-3">
                        <div class="col-md-3">
                            <label class="small fw-bold">{{ $t('outputTable') }}</label>
                            <input v-model="content.outputTableName" class="form-control form-control-sm" />
                        </div>
                        <div class="col-md-3">
                            <label class="small text-muted">{{ $t('outputIdName') }}</label>
                            <input v-model="content.outputIdColumn" class="form-control form-control-sm" placeholder="objectId" />
                        </div>
                        <div class="col-md-3">
                            <label class="small text-muted">{{ $t('outputFromName') }}</label>
                            <input v-model="content.outputFromColumn" class="form-control form-control-sm" placeholder="from" />
                        </div>
                        <div class="col-md-3">
                            <label class="small text-muted">{{ $t('outputToName') }}</label>
                            <input v-model="content.outputToColumn" class="form-control form-control-sm" placeholder="to" />
                        </div>
                    </div>

                    <div class="row g-2 mt-3">
                        <div class="col-md-12">
                            <label class="small fw-bold">{{ $t('outputFilter') }}</label>
                            <input v-model="content.outputFilter" class="form-control form-control-sm" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="card mb-3">
                <div class="card-body">
                    <div class="d-flex align-items-center gap-2 mb-3">
                        <div class="rounded-circle bg-primary-subtle text-primary d-inline-flex align-items-center justify-content-center" style="width: 36px; height: 36px;">
                            <i class="fa-solid fa-diagram-project"></i>
                        </div>
                        <span class="fw-semibold">{{ $t('aggregation') }}</span>
                    </div>

                    <div class="row g-2 mb-3">
                        <div class="col-md-3">
                            <label class="small fw-bold">{{ $t('inputTable') }}</label>
                            <select v-model="content.inputTable" class="form-select form-select-sm">
                                <option value="">{{ $t('selectTable') }}</option>
                                <option v-for="t in tables" :key="t.name" :value="t.name">{{ t.name }}</option>
                            </select>
                        </div>
                    </div>
                    <div v-if="content.inputTable">
                        <div class="d-flex justify-content-between align-items-center mb-2">
                            <label class="small fw-bold">{{ $t('groupBy') }}</label>
                            <button class="btn btn-sm btn-outline-primary" @click="addGroupBy">
                                <i class="fas fa-plus"></i> {{ $t('addGroupBy') }}
                            </button>
                        </div>
                         <table class="table table-sm table-bordered mb-3" v-if="content.groupBy && content.groupBy.length > 0">
                            <thead>
                                <tr class="small text-muted">
                                    <th class="pl-1">{{ $t('column') }}</th>
                                    <th class="pl-1">{{ $t('alias') }}</th>
                                    <th style="width: 70px" class="pl-1">{{ $t('temporary') }}</th>
                                    <th style="width: 50px"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(agg, i) in content.groupBy" :key="i">
                                    <td>
                                        <select v-model="agg.column" class="form-select form-select-sm">
                                            <option value=""></option>
                                            <option v-for="col in inputColumns" :key="col.name" :value="col.name">{{ col.name }}</option>
                                        </select>
                                    </td>
                                    <td>
                                        <input type="text" class="form-control form-control-sm" :placeholder="agg.name || ''" v-model="agg.alias">
                                    </td>
                                    <td class="text-center">
                                        <input class="form-check-input mt-2" type="checkbox" v-model="agg.temporary">
                                    </td>
                                    <td class="text-center">
                                        <button class="btn btn-sm btn-outline-danger " @click="content.groupBy.splice(i, 1)">
                                            <i class="fas fa-trash-alt"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <!-- <table class="table table-sm table-bordered mb-3" v-if="inputColumns.length > 0">
                            <tbody>
                                <tr v-for="col in inputColumns" :key="col.name">
                                    <td style="width: 40px" class="text-center">
                                        <input class="form-check-input mt-0" type="checkbox" 
                                            :value="col.name" v-model="content.groupByColumns">
                                    </td>
                                    <td class="small">{{ col.name }}</td>
                                    <td class="small text-muted">{{ col.dataType }}</td>
                                </tr>
                            </tbody>
                        </table> -->

                        <div class="d-flex justify-content-between align-items-center mb-2">
                            <label class="small fw-bold">{{ $t('aggregateColumns') }}</label>
                            <button class="btn btn-sm btn-outline-primary" @click="addAggregation">
                                <i class="fas fa-plus"></i> {{ $t('addColumn') }}
                            </button>
                        </div>
                        <table class="table table-sm table-bordered" v-if="content.aggregations && content.aggregations.length > 0">
                            <thead>
                                <tr class="small text-muted">
                                    <th class="pl-1">{{ $t('column') }}</th>
                                    <th class="pl-1">{{ $t('alias') }}</th>
                                    <th class="pl-1">{{ $t('dataType') }}</th>
                                    <th class="pl-1">{{ $t('function') }}</th>
                                    <th style="width: 50px"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(agg, i) in content.aggregations" :key="i">
                                    <td>
                                        <select v-model="agg.column" class="form-select form-select-sm" @change="prefillAggregation(agg)">
                                            <option value=""></option>
                                            <option v-for="col in inputColumns" :key="col.name" :value="col.name">{{ col.name }}</option>
                                        </select>
                                    </td>
                                    <td>
                                        <input type="text" class="form-control form-control-sm" :placeholder="agg.name || ''" v-model="agg.alias">
                                    </td>
                                    <td>
                                        <input type="text" class="form-control form-control-sm" v-model="agg.dataType" :placeholder="agg.dataType || ''">
                                    </td>
                                    <td>
                                        <select v-model="agg.function" class="form-select form-select-sm">
                                            <option value=""></option>
                                            <option v-for="fn in aggregations" :key="fn.value" :value="fn.value">{{ fn.label }}</option>
                                        </select>
                                    </td>
                                    <td class="text-center">
                                        <button class="btn btn-sm btn-outline-danger " @click="content.aggregations.splice(i, 1)">
                                            <i class="fas fa-trash-alt"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <!-- CSD -->
        <div v-if="content.batchType === 'CSD'">
            <div class="card mb-3">
                <div class="card-body">
                    <div class="d-flex align-items-center gap-2 mb-3">
                        <div class="rounded-circle bg-primary-subtle text-primary d-inline-flex align-items-center justify-content-center" style="width: 36px; height: 36px;" >
                            <i class="fa-regular fa-file"></i>
                        </div>
                        <span class="fw-semibold">{{ $t('output') }}</span>
                    </div>
                    <div class="row g-2 mb-4">
                        <div class="col-md-3">
                            <label class="form-label small text-muted">{{ $t('outputTableName') }}</label>
                            <input v-model="content.outputTableName" class="form-control form-control-sm" style="max-width: 400px"/>
                        </div>
                        <div class="col-md-3">
                            <label class="form-label small text-muted">{{ $t('outputIdName') }}</label>
                            <input v-model="content.outputIdColumn" class="form-control form-control-sm" placeholder="objectId" />
                        </div>
                        <div class="col-md-3">
                            <label class="form-label small text-muted">{{ $t('outputFromName') }}</label>
                            <input v-model="content.outputFromColumn" class="form-control form-control-sm" placeholder="from" />
                        </div>
                        <div class="col-md-3">
                            <label class="form-label small text-muted">{{ $t('outputToName') }}</label>
                            <input v-model="content.outputToColumn" class="form-control form-control-sm" placeholder="to" />
                        </div>
                    </div>
                    
                    <div class="row g-2 mt-3">
                        <div class="col-md-12">
                            <label class="small fw-bold">{{ $t('outputFilter') }}</label>
                            <input v-model="content.outputFilter" class="form-control form-control-sm" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="card mb-3">
                <div class="card-body">
                    <div class="d-flex align-items-center gap-2 mb-3">
                        <div class="rounded-circle bg-primary-subtle text-primary d-inline-flex align-items-center justify-content-center" style="width: 36px; height: 36px;">
                            <i class="fa-solid fa-download"></i>
                        </div>
                        <span class="fw-semibold">{{ $t('inputs') }}</span>
                    </div>

                    <div v-for="(tbl, i) in (content.csdTables || [])" :key="i" class="card mb-3">
                        <div class="card-header bg-white d-flex justify-content-between align-items-center" style="cursor: pointer" @click="tbl.collapsed = !tbl.collapsed">
                            <div class="d-flex align-items-center gap-2">
                                <i :class="['fas', tbl.collapsed ? 'fa-chevron-right' : 'fa-chevron-down']" style="width: 20px"></i>
                                <span class="fw-semibold small">
                                    {{ $t('input') }} {{ i + 1 }} <span v-if="tbl.table" class="text-muted">- {{ tbl.table }}</span>
                                </span>
                            </div>
                            <button class="btn btn-sm btn-outline-danger" @click="content.csdTables.splice(i, 1)">
                                <i class="fas fa-trash-alt"></i>
                            </button>
                        </div>

                        <div class="card-body" v-show="!tbl.collapsed">
                            <div class="row g-2 mb-3">
                                <div class="col-md-3">
                                    <label class="small fw-bold">{{ $t('inputTable') }}</label>
                                    <select v-model="tbl.table" class="form-select form-select-sm">
                                        <option value="">{{ $t('selectTable') }}</option>
                                        <option v-for="t in tables" :key="t.name" :value="t.name">{{ t.name }}</option>
                                    </select>
                                </div>
                                <div class="col-md-3">
                                    <label class="small ">ID</label>
                                    <select v-model="tbl.idColumn" class="form-select form-select-sm" :disabled="!tbl.table">
                                        <option value=""></option>
                                        <option v-for="c in getColumnsForTable(tbl.table)" :key="c.name" :value="c.name">{{ c.name }}</option>
                                    </select>
                                </div>
                                <div class="col-md-3">
                                    <label class="small ">FROM</label>
                                    <select v-model="tbl.fromColumn" class="form-select form-select-sm" :disabled="!tbl.table">
                                        <option value=""></option>
                                        <option v-for="c in getColumnsForTable(tbl.table)" :key="c.name" :value="c.name">{{ c.name }}</option>
                                    </select>
                                </div>
                                <div class="col-md-3">
                                    <label class="small ">TO</label>
                                    <select v-model="tbl.toColumn" class="form-select form-select-sm" :disabled="!tbl.table">
                                        <option value=""></option>
                                        <option v-for="c in getColumnsForTable(tbl.table)" :key="c.name" :value="c.name">{{ c.name }}</option>
                                    </select>
                                </div>
                            </div>

                            <div class="d-flex justify-content-between align-items-center mb-2">
                                <label class="small text-muted fw-bold mb-0">{{ $t('includeColumns') }}</label>
                                <button class="btn btn-sm btn-outline-primary" @click="addCsdColumn(tbl)" :disabled="!tbl.table">
                                    <i class="fas fa-plus"></i> {{ $t('addColumn') }}
                                </button>
                            </div>
                            <table class="table table-sm table-bordered mb-0" v-if="tbl.selectedColumns && tbl.selectedColumns.length > 0">
                                <thead>
                                    <tr class="small text-muted">
                                        <th class="pl-1">{{ $t('column') }}</th>
                                        <th class="pl-1">{{ $t('alias') }}</th>
                                        <th class="pl-1">{{ $t('dataType') }}</th>
                                        <th style="width: 50px"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(col, j) in tbl.selectedColumns" :key="j">
                                        <td>
                                            <select v-model="col.name" class="form-select form-select-sm" @change="prefillDataType(tbl, col)">
                                                <option value=""></option>
                                                <option v-for="c in getColumnsForTable(tbl.table)" :key="c.name" :value="c.name">{{ c.name }}</option>
                                            </select>
                                        </td>
                                        <td>
                                            <input type="text" class="form-control form-control-sm" :placeholder="col.name || ''" v-model="col.alias">
                                        </td>
                                        <td>
                                            <input type="text" class="form-control form-control-sm" v-model="col.dataType" placeholder="nvarchar(MAX)">
                                        </td>
                                        <td class="text-center">
                                            <button class="btn btn-sm btn-outline-danger" @click="tbl.selectedColumns.splice(j, 1)">
                                                <i class="fas fa-trash-alt"></i>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <button class="btn btn-sm btn-outline-primary" @click="addCsdTable">
                        <i class="fas fa-plus"></i> {{ $t('addInput') }}
                    </button>
                </div>
            </div>
        </div>
        <div class="card mb-3">
            <div class="card-body">
                <div class="d-flex align-items-center gap-2 mb-3">
                    <div class="rounded-circle bg-primary-subtle text-primary d-inline-flex align-items-center justify-content-center" style="width: 36px; height: 36px;">
                        <i class="fa-solid fa-shuffle"></i>
                    </div>
                    <span class="fw-semibold">{{ $t('transformations') }}</span>
                </div>
                <div v-for="(tbl, i) in (content.transformations || [])" :key="i" class="card mb-3">
                    <div class="card-header bg-white d-flex justify-content-between align-items-center" style="cursor: pointer" @click="tbl.collapsed = !tbl.collapsed">
                        <div class="d-flex align-items-center gap-2">
                            <i :class="['fas', tbl.collapsed ? 'fa-chevron-right' : 'fa-chevron-down']" style="width: 20px"></i>
                            <span class="fw-semibold small">
                                {{ $t('transformation') }} {{ i + 1 }} <span v-if="tbl.table" class="text-muted">- {{ tbl.table }}</span>
                            </span>
                        </div>
                        <button class="btn btn-sm btn-outline-danger" @click="content.transformations.splice(i, 1)">
                            <i class="fas fa-trash-alt"></i>
                        </button>
                    </div>

                    <div class="card-body" v-show="!tbl.collapsed">
                        <div class="row g-2 mb-3">
                            <div class="col-md-3">
                                <label class="small fw-bold">{{ $t('transformationTable') }}</label>
                                <select v-model="tbl.table" class="form-select form-select-sm">
                                    <option value="">{{ $t('selectTable') }}</option>
                                    <option v-for="t in tables" :key="t.name" :value="t.name">{{ t.name }}</option>
                                </select>
                            </div>
                            <div class="col-md-3">
                                <label class="small text-muted">ID</label>
                                <select v-model="tbl.idColumn" class="form-select form-select-sm" :disabled="!tbl.table">
                                    <option v-for="c in getColumnsForTable(tbl.table)" :key="c.name" :value="c.name">{{ c.name }}</option>
                                </select>
                            </div>
                            <div class="col-md-3">
                                <label class="small text-muted">FROM</label>
                                <select v-model="tbl.fromColumn" class="form-select form-select-sm" :disabled="!tbl.table">
                                    <option v-for="c in getColumnsForTable(tbl.table)" :key="c.name" :value="c.name">{{ c.name }}</option>
                                </select>
                            </div>
                            <div class="col-md-3">
                                <label class="small text-muted">TO</label>
                                <select v-model="tbl.toColumn" class="form-select form-select-sm" :disabled="!tbl.table">
                                    <option v-for="c in getColumnsForTable(tbl.table)" :key="c.name" :value="c.name">{{ c.name }}</option>
                                </select>
                            </div>
                        </div>

                        <table class="table table-sm table-bordered mb-0" v-if="tbl.selectedColumns && tbl.selectedColumns.length > 0">
                            <thead>
                                <tr class="small text-muted">
                                    <th class="pl-1">{{ $t('column') }}</th>
                                    <th class="pl-1">{{ $t('alias') }}</th>
                                    <th class="pl-1">{{ $t('dataType') }}</th>
                                    <th class="pl-1">{{ $t('function') }}</th>
                                    <th style="width: 70px" class="pl-1">{{ $t('temporary') }}</th>
                                    <th style="width: 50px"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(col, j) in tbl.selectedColumns" :key="j">
                                    <td>
                                        <select v-model="col.name" class="form-select form-select-sm" @change="prefillDataType(tbl, col)">
                                            <option value=""></option>
                                            <option v-for="c in getColumnsForTable(tbl.table)" :key="c.name" :value="c.name">{{ c.name }}</option>
                                        </select>
                                    </td>
                                    <td>
                                        <input type="text" class="form-control form-control-sm" :placeholder="col.name || ''" v-model="col.alias">
                                    </td>
                                    <td>
                                        <input type="text" class="form-control form-control-sm" v-model="col.dataType" :placeholder="col.dataType || ''">
                                    </td>
                                    <td>
                                        <select v-model="col.transformation" class="form-select form-select-sm">
                                            <option value=""></option>
                                            <option v-for="fn in transformations" :key="fn.value" :value="fn.value">{{ fn.label }}</option>
                                        </select>
                                    </td>
                                    <td class="text-center">
                                        <input class="form-check-input mt-2" type="checkbox" v-model="col.temporary">
                                    </td>
                                    <td class="text-center">
                                        <button class="btn btn-sm btn-outline-danger" @click="tbl.selectedColumns.splice(j, 1)">
                                            <i class="fas fa-trash-alt"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    <button class="btn btn-sm btn-outline-primary mt-2" @click="addTransformationColumn(tbl)" :disabled="!tbl.table">
                        <i class="fas fa-plus"></i> {{ $t('addColumn') }}
                    </button>
                    </div>
                </div>
                <button class="btn btn-sm btn-outline-primary" @click="addTransformation">
                    <i class="fas fa-plus"></i> {{ $t('addTransformation') }}
                </button>
            </div>
        </div>
        <div class="card mb-3">
            <div class="card-body">
                <div class="d-flex align-items-center gap-2 mb-3">
                    <div class="rounded-circle bg-primary-subtle text-primary d-inline-flex align-items-center justify-content-center" style="width: 36px; height: 36px;">
                        <i class="fa-solid fa-code"></i>
                    </div>
                    <span class="fw-semibold">{{ $t('expressions') }}</span>
                </div>
                <div v-for="(expr, i) in (content.expressions || [])" :key="i" class="card mb-2">
                    <div class="card-header bg-white d-flex justify-content-between align-items-center" style="cursor: pointer" @click="expr.collapsed = !expr.collapsed">
                        <div class="d-flex align-items-center gap-2">
                            <i :class="['fas', expr.collapsed ? 'fa-chevron-right' : 'fa-chevron-down']" style="width: 20px"></i>
                            <span class="fw-semibold small">
                                {{ expr.alias || $t('expression') + ' ' + (i + 1) }}
                            </span>
                        </div>
                        <div class="d-flex gap-1" @click.stop>
                            <button class="btn btn-sm btn-outline-secondary" @click="moveExpression(i, -1)" :disabled="i === 0">
                                <i class="fas fa-chevron-up"></i>
                            </button>
                            <button class="btn btn-sm btn-outline-secondary" @click="moveExpression(i, 1)" :disabled="i === content.expressions.length - 1">
                                <i class="fas fa-chevron-down"></i>
                            </button>
                            <button class="btn btn-sm btn-outline-danger" @click="content.expressions.splice(i, 1)">
                                <i class="fas fa-trash-alt"></i>
                            </button>
                        </div>
                    </div>
                    <div class="card-body" v-show="!expr.collapsed">
                        <div class="row g-2 mb-2">
                            <div class="col-md-4">
                                <label class="">{{ $t('alias') }}</label>
                                <input type="text" class="form-control form-control-sm" v-model="expr.alias" :placeholder="$t('alias')">
                            </div>
                            <div class="col-md-3">
                                <label class="">{{ $t('dataType') }}</label>
                                <input type="text" class="form-control form-control-sm" v-model="expr.dataType" :placeholder="$t('dataType')">
                            </div>
                            <div class="col-md-3 d-flex align-items-end">
                                <div class="form-check mb-1">
                                    <input class="form-check-input" type="checkbox" :id="`expr-tmp-${i}`" v-model="expr.temporary">
                                    <label class="form-check-label" :for="`expr-tmp-${i}`">{{ $t('temporary') }}</label>
                                </div>
                            </div>
                        </div>
                        <label class="">{{ $t('expression') }}</label>
                        <textarea class="form-control form-control-sm" rows="4" v-model="expr.expression" :placeholder="$t('expressionPlaceholder')"></textarea>
                    </div>
                </div>
                <button class="btn btn-sm btn-outline-primary" @click="addExpression">
                    <i class="fas fa-plus"></i> {{ $t('addExpression') }}
                </button>
            </div>
        </div>
        <DataBatchRunModal v-if="showRunModal" :batch="content" @close="showRunModal = false" />
    </div>
    <div v-else class="text-muted">{{ $t('loading') }}...</div>
</template>

<script>
import DataBatchApi from '../../api/server/databatch';
import DataSpaceApi from '../../api/server/dataspace';
import DataBatchRunModal from './DataBatchRunModal.vue';

export default {
    name: 'DataBatchDetail',
    components: {
        DataBatchRunModal
    },
    data() {
        return {
            saving: false,
            running: false,
            showRunModal: false,
            tables: [],
            inputColumns: [],
            copyExcludedColumns: [],
            content: null,
            transformations: [
                { value: 'minimum', label: 'Minimum' },
                { value: 'maximum', label: 'Maximum' },
                { value: 'mostLength', label: 'Most length' },
                { value: 'sum', label: 'Sum' },
                { value: 'weightedSum', label: 'Weighted sum' },
                { value: 'statisticalAverage', label: 'Statistical average' },
                { value: 'weightedAverage', label: 'Weighted average' },
            ],
            aggregations: [
                { value: 'minimum', label: 'Minimum' },
                { value: 'maximum', label: 'Maximum' },
                { value: 'sum', label: 'Sum' },
                { value: 'weightedSum', label: 'Weighted sum' },
                { value: 'statisticalAverage', label: 'Statistical average' },
                { value: 'count', label: 'Count' }
            ]
        };
    },
    watch: {
        'content.inputTable'(val) {
            // naplneni columns podle tabulky
            if (val) {
                var table = this.tables.find(t => t.name === val);
                this.inputColumns = table ? table.columns : [];

                    if (!this.content.groupByColumns)
                        this.content.groupByColumns = [];
            } else {
                this.inputColumns = [];
            }
        }
    },
    computed: {
        dataSpaceId() {
            return this.$route.params.id;
        },
        batchId() {
            return this.$route.params.batchId;
        },
        togglableCopyColumns() {
            return this.getColumnsForTable(this.content.inputTable).filter(c => !this.isKeyColumn(c.name)).map(c => c.name);
        },
        allCopyChecked() {
            return this.togglableCopyColumns.every(n => !this.isExcluded(n));
        }
    },
    async mounted() {
        await this.loadTables();
        await this.loadBatch();
    },
    methods: {
        async loadBatch() {
            this.content = await DataBatchApi.dataBatchDetail(this.dataSpaceId, this.batchId);
            if (this.content.csdTables) {
                this.content.csdTables.forEach(tbl => {
                    if (!tbl.selectedColumns) tbl.selectedColumns = [];
                });
            }
            if (this.content.transformations) {
                this.content.transformations.forEach(tbl => {
                    if (!tbl.selectedColumns) tbl.selectedColumns = [];
                });
            }

            if (!this.content.copyExcludedColumns)
                this.content.copyExcludedColumns = [];
        },
        async loadTables() {
            this.tables = await DataSpaceApi.tables(this.dataSpaceId);
        },
        toggleAllCopyColumns() {
            if (!this.content.copyExcludedColumns)
                this.content.copyExcludedColumns = [];

            if (this.allCopyChecked) {
                this.togglableCopyColumns.forEach(n => {
                    if (!this.content.copyExcludedColumns.includes(n))
                        this.content.copyExcludedColumns.push(n);
                });
            } else {
                this.content.copyExcludedColumns = this.content.copyExcludedColumns.filter(n => !this.togglableCopyColumns.includes(n));
            }
        },
        isExcluded(name) {
            if (!this.content.copyExcludedColumns)
                this.content.copyExcludedColumns = [];

            return this.content.copyExcludedColumns.includes(name);
        },
        toggleCopyColumn(name) {
            if (!this.content.copyExcludedColumns)
                this.content.copyExcludedColumns = [];

            var i = this.content.copyExcludedColumns.indexOf(name);
            if (i === -1)
                this.content.copyExcludedColumns.push(name);
            else
                this.content.copyExcludedColumns.splice(i, 1);
        },
        isKeyColumn(name) {
            return name === this.content.inputIdColumn || name === this.content.inputFromColumn || name === this.content.inputToColumn;
        },
        async onInputTableChange() {
            var table = this.tables.find(t => t.name === this.content.inputTable);

            this.inputColumns = table ? table.columns : [];
        },
        getColumnsForTable(tableName) {
            var table = this.tables.find(t => t.name === tableName);
            return table ? table.columns : [];
        },
        addAggregation() {
            if (!this.content.aggregations)
                this.content.aggregations = [];

            this.content.aggregations.push({ column: '', alias: '', dataType: '', function: '', temporary: false });
        },
        addGroupBy() {
            if (!this.content.groupBy)
                this.content.groupBy = [];

            this.content.groupBy.push({ column: '' });
        },
        addCsdTable() {
            if (!this.content.csdTables)
                this.content.csdTables = [];

            this.content.csdTables.push({ table: '', idColumn: '', fromColumn: '', toColumn: '', selectedColumns: [] });
        },
        addCsdColumn(tbl) {
            if (!tbl.selectedColumns)
                tbl.selectedColumns = [];

            tbl.selectedColumns.push({ name: '', alias: '', dataType: '',temporary: false });
        },
        prefillDataType(tbl, col) {
            if (!col.name)
                return;

            var tableCol = this.getColumnsForTable(tbl.table).find(c => c.name === col.name);
            console.log(tableCol)
            if (tableCol)
                col.dataType = tableCol.dataType;
        },
        prefillAggregation(agg) {
            if (!agg.column) 
                return;

            var col = this.inputColumns.find(c => c.name === agg.column);
            if (col) {
                if (!agg.alias)
                    agg.alias = col.name;
                if (!agg.dataType)
                    agg.dataType = col.dataType;
            }
        },
        addTransformation() {
            if (!this.content.transformations)
                this.content.transformations = [];

            this.content.transformations.push({ table: '', idColumn: '', fromColumn: '', toColumn: '', selectedColumns: [] });
        },
        addTransformationColumn(tbl) {
            if (!tbl.selectedColumns)
                tbl.selectedColumns = [];

            tbl.selectedColumns.push({ name: '', alias: '', dataType: '', transformation: '', temporary: false });
        },
        addExpression() {
            if (!this.content.expressions)
                this.content.expressions = [];
            this.content.expressions.push({ alias: '', dataType: '', expression: '', temporary: false });
        },
        moveExpression(index, direction) {
            var arr = this.content.expressions;
            var newIndex = index + direction;
            var item = arr.splice(index, 1)[0];
            arr.splice(newIndex, 0, item);
        },
        async saveBatch() {
            this.saving = true;
            this.content.outputTableName = this.content.outputTableName.trim();
            await DataBatchApi.dataBatchUpdate(this.dataSpaceId, this.batchId, this.content);
            this.showSuccess();
        
            this.saving = false;
        },
        async runBatch() {
            this.saving = true;
            try {
                this.content.outputTableName = this.content.outputTableName.trim();
                await DataBatchApi.dataBatchUpdate(this.dataSpaceId, this.batchId, this.content);
                this.saving = false;
                this.showRunModal = true;
            } catch (error) {
                this.saving = false;
                this.showRunFail();
            }
        },
        goBack() {
            this.$router.push(`/dataspace/${this.dataSpaceId}/batches`);
        },
        isTableNameInvalid() {
            if(!this.content.outputTableName)
                return true;
            var trimmedName = this.content.outputTableName.trim();
            return !trimmedName || trimmedName.includes(" ");
        }
    },
    notifications: {
        showSuccess: {
            title: 'success',
            message: 'batchUpdated',
            type: 'success'
        },
        showRunSuccess: {
            title: 'success',
            message: 'batchRunSuccessful',
            type: 'success'
        },
        showRunFail: {
            title: 'failed',
            message: 'batchRunUnsuccessful',
            type: 'error'
        }
    },
};
</script>